export default "__VITE_ASSET__3c72597e__"